// src/components/Sidebar.js
import React from 'react';
import { 
  BarChart3, 
  TrendingUp, 
  Eye, 
  Calendar,
  Bell, 
  Briefcase, 
  Settings, 
  HelpCircle, 
  Info 
} from 'lucide-react';

const Sidebar = ({ currentPage, collapsed, onPageChange, alertCount, isMobile }) => {
  const navigationItems = [
    {
      section: 'Analytics Tools',
      items: [
        { id: 'dashboard', icon: BarChart3, label: 'Dashboard' },
        { id: 'price-analysis', icon: TrendingUp, label: 'Price Analysis' },
        { id: 'oi-monitoring', icon: Eye, label: 'OI Monitoring' },
        { id: 'daily-tracker', icon: Calendar, label: 'Daily Tracker' },
        { id: 'pairtrading', icon: BarChart3, label: 'Pair Trading' }
      ]
    },
    {
      section: 'Management',
      items: [
        { id: 'alerts', icon: Bell, label: 'Alert Center', badge: alertCount },
        { id: 'portfolio', icon: Briefcase, label: 'Portfolio' },
        { id: 'settings', icon: Settings, label: 'Settings' }
      ]
    },
    {
      section: 'Support',
      items: [
        { id: 'help', icon: HelpCircle, label: 'Help & FAQ' },
        { id: 'about', icon: Info, label: 'About' }
      ]
    }
  ];

  // Generate className based on mobile and collapsed state
  const getSidebarClass = () => {
    let className = 'sidebar';
    if (isMobile) {
      // On mobile, use 'show' class instead of checking collapsed
      className += collapsed ? '' : ' show';
    } else {
      // On desktop, use collapsed as normal
      className += collapsed ? ' collapsed' : '';
    }
    return className;
  };

  return (
    <nav className={getSidebarClass()}>
      <div className="sidebar-header">
        <div className="logo-icon">B</div>
        <div className="logo-text">
          <h1>Binance Analytics Pro</h1>
          <p>Professional Trading</p>
        </div>
      </div>
      
      <div className="sidebar-nav">
        {navigationItems.map((section, sectionIndex) => (
          <div key={sectionIndex} className="nav-section">
            <div className="nav-section-title">{section.section}</div>
            {section.items.map((item) => {
              const IconComponent = item.icon;
              return (
                <div
                  key={item.id}
                  className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
                  onClick={() => onPageChange(item.id)}
                >
                  <IconComponent size={16} />
                  <span>{item.label}</span>
                  {item.badge > 0 && (
                    <div className="alert-badge">{item.badge}</div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      <div className="sidebar-footer">
        <div className="status-indicator">
          <div className="status-dot online"></div>
          <span>API Connected</span>
        </div>
        <div className="sidebar-version">v2.1.0</div>
      </div>
    </nav>
  );
};

export default Sidebar;